export const FrxTheme = "frx-theme";
export const TokenKey = "token";
export const UserKey = "user";
export const STATUS_UNASSIGNED = "UNASSIGNED";
export const STATUS_ASSIGNED = "ASSIGNED";
export const TestKitStatusOptions = [
  { label: "All", value: "ALL" },
  { label: "Unassigned", value: STATUS_UNASSIGNED },
  { label: "Assigned", value: STATUS_ASSIGNED }
];
